module.exports = __webpack_public_path__ + "img/solution1.78c80fd6.png";